import { GroupId } from '@sr/types';
import { getGroupDescription } from './group-utils';
import { Box, Image } from 'v1/ui';

export default function NoMessages({ groupId }: { groupId: GroupId }) {
  const description = getGroupDescription(groupId);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        px: 4,
        pb: 6,
        color: 'black50',
        fontSize: 14,
      }}
    >
      <Box sx={{ fontSize: 15, mb: 7 }}>{description}</Box>
      <Image
        src="https://assets.standardresume.co/image/upload/f_auto,w_280,c_fill/v1635282923/app/reviews/nice-work_llqjb0.png"
        sx={{
          width: '100%',
          maxWidth: 140,
          height: 'auto',
          mb: 4,
        }}
      />
      <Box sx={{ mb: 6 }}>No suggestions to address.</Box>
    </Box>
  );
}
